import { object, setLocale, string } from 'yup'
setLocale({
  // use constant translation keys for messages without values
  mixed: {
    required: 'common.required',
    notType: 'common.required'
  }
})
export default object().shape({
  name: string().required().typeError()
})
